module.exports = __webpack_public_path__ + "static/media/z_score_dark.e528ca86.svg";